import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import {selectDate} from '../../actions';

import {Api,Today,Time} from '../../util';
import {Error} from '../../components/modal';
import Loading from '../../components/loading';

import FilterContainer from '../FilterContainer';
import ContentContainer from './ContentContainer';
import Channel from '../../components/channel';
import TextContainer from './TextMode';

class ScheduleContainer extends Component {
  constructor(props){
    super(props);
    this.state = {
      viewMode: true,
      textMode: false,
      chId: '1',
      keyword: '',
      ssom: 0,
      seom: 86400000,
      scheduleList: [],
      errorContent: {},
      showError: false,
      loadingToggle: false
    };
    this.changeViewMode = this.changeViewMode.bind(this);

    this.changeChId = this.changeChId.bind(this);
    this.handleOnKeywordChange = this.handleOnKeywordChange.bind(this);
    this.handleSsomSelect = this.handleSsomSelect.bind(this);
    this.handleSeomSelect = this.handleSeomSelect.bind(this);

    this.handleHide = this.handleHide.bind(this);
    this.getEpgInfo = this.getEpgInfo.bind(this);
  }
  
  async getEpgInfo(date = Time.getToday()){
    const {
      chId,
      ssom,
      seom,
      keyword
    } = this.state;
    this.setState({
      loadingToggle: true
    });
    try{
      const epg = await Api.SearchEpgEs({
        pageFrom: 0,
        pageSize: 100,
        chs: chId,
        begDate: date,
        endDate: date,
        start: ssom,
        stop: seom,
        keyword
      });       
      const scheduleList = epg.files.hits || [];
      this.setState({
        scheduleList
      });
    }catch(e){
      // NOTE: 스케줄이 없는 경우는 오류창을 띄우지 않는다.
      if(e.detail && !e.detail.includes('There is no broadcast schedule.')) {
        console.error(e);
        this.setState({
          showModal: true,
          errorContent: e
        });
      }
      this.setState({showError: true})

    } finally {
      this.setState({
        loadingToggle: false
      });
    }
  }

  handleHide(){
    this.setState({showError: false});
  }

  changeChId(chId){
    this.setState({chId});
  }

  changeViewMode(mode){
    this.setState({
      viewMode: mode === 'viewMode' ? true : false,
      textMode: mode === 'textMode' ? true : false
    });
  }

  handleOnKeywordChange(keyword){
    this.setState({keyword});
  }
  handleSsomSelect(ssom){
      this.setState({ssom});
  }
  handleSeomSelect(seom){
      this.setState({seom});
  }

  render() {
    const {
      display,
      selectedMenu,
    } = this.props;
    const {
      showError,
      loadingToggle,
      errorContent,
      viewMode,

      ssom,
      seom,
      scheduleList
    } = this.state;
    const style = {display: display ? 'flex' : 'none'};
   
    return (
      <div className='content container schedule' style={style}>
       {selectedMenu === 'SCHEDULE' &&
          <Fragment>
            <FilterContainer
              // viewMode={viewMode}
              // changeViewMode={this.changeViewMode}
             />
            {viewMode ? <Channel /> : <TextContainer.Header
              onStart={ssom}
              onStop={seom}
              getEpgInfo={this.getEpgInfo}
              changeChId={this.changeChId}
              handleSsomSelect={this.handleSsomSelect}
              handleSeomSelect={this.handleSeomSelect}
              handleOnKeywordChange={this.handleOnKeywordChange}
            /> }
          </Fragment>
        }
        {viewMode 
        ?
          <Fragment>
            <div className='list cover'></div>
            <ContentContainer />
          </Fragment>
        :
        <div className="text-schedule-container">
          {<TextContainer.Content 
            scheduleList={scheduleList}
            getEpgInfo={this.getEpgInfo}
          />}
        </div>
        }
        {showError && <Error 
          handleHide={this.handleHide}
          errorContent={errorContent}
        />}
        {loadingToggle && <Loading /> }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedDate: state.selectedDate,
    selectedMenu: state.selectedMenu
  }
};

ScheduleContainer = connect(mapStateToProps)(ScheduleContainer);

export default ScheduleContainer;


// WEBPACK FOOTER //
// ./src/containers/schedule/index.js